import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";

export interface EditBusinessWebsiteScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "EditBusinessWebsiteScreen"
  > {}

export const EditBusinessWebsiteScreen = ({
  navigation,
}: EditBusinessWebsiteScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { website = "" } = globalSettings;
  const [value, setValue] = useState(website || "");

  const isDirty = useMemo(() => {
    return value != website;
  }, [value, website]);

  const isValid = useMemo(() => {
    return true;
  }, [value]);

  const handleOnSave = useCallback(async () => {
    if (!isValid) return;
    return updateGlobalSettings({
      website: value,
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value, isValid]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label="Edit Business Website" />,
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Website"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
      />
    </Page>
  );
};
